import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './EnableCustomersModal.scss';

export const EnableCustomersModal = ({
  isOpen,
  onClose,
  onConfirm,
  lastPublish,
  isLoadingEnableCoustomers,
  numberOfEnabledUsers,
}) => {
  const [
    enableCustomersSelectedOption,
    setEnableCustomersSelectedOption,
  ] = useState('enable');

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      classes={{ paper: styles.dialog_root }}
      disableBackdropClick
    >
      <DialogTitle>
        <span className={styles.dialog_header}>
          {lastPublish
            ? '✅ Published successfully'
            : 'Make your content visible'}
        </span>
      </DialogTitle>
      {// eslint-disable-next-line no-nested-ternary
      isLoadingEnableCoustomers ? (
        <div
          style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}
        >
          <CircularProgress />
        </div>
      ) : lastPublish ? (
        <div className={styles.dialog_content}>
          <div style={{ marginBottom: 5 }}>
            Your custom content is now live and visible to{' '}
            {numberOfEnabledUsers || 'none of your'} client
            {numberOfEnabledUsers === 1 ? '' : 's'}.
          </div>
          <div style={{ marginBottom: 5 }}>
            To hide it from specific clients, adjust their content settings in
            their profile.
          </div>
          <div style={{ marginBottom: 5 }}>
            To change the default for new clients, update your settings in
            Preferences.
          </div>
        </div>
      ) : (
        <div className={styles.dialog_content}>
          <div style={{ marginBottom: 20 }}>
            Your custom content is still off for all of your clients. Want to
            enable it so they can see what you just published?
          </div>
          <RadioGroup
            value={enableCustomersSelectedOption}
            onChange={e => {
              setEnableCustomersSelectedOption(e.target.value);
            }}
          >
            <FormControlLabel
              value="enable"
              control={
                <Radio
                  classes={{
                    checked: styles.checked,
                    root: styles.radio_root,
                  }}
                  color="primary"
                />
              }
              label={
                <span style={{ fontSize: 12 }}>
                  Publish and enable for all clients now
                </span>
              }
              classes={{
                root: styles.radio_label,
              }}
            />
            <FormControlLabel
              value="dont_enable"
              control={
                <Radio
                  classes={{
                    checked: styles.checked,
                    root: styles.radio_root,
                  }}
                  color="primary"
                />
              }
              label={
                <span style={{ fontSize: 12 }}>
                  Publish and keep it off (I’ll do it later for each individual
                  client)
                </span>
              }
              classes={{
                root: styles.radio_label,
              }}
            />
          </RadioGroup>
        </div>
      )}
      <DialogActions style={{ marginRight: 20, marginTop: 20 }}>
        <Button
          onClick={onClose}
          variant="text"
          color="default"
          disabled={isLoadingEnableCoustomers}
        >
          <span className={styles.button}>
            {lastPublish ? 'Close' : 'Cancel'}
          </span>
        </Button>
        {lastPublish ? null : (
          <Button
            onClick={() => {
              onConfirm(enableCustomersSelectedOption);
            }}
            color="primary"
            variant="contained"
            style={{ fontSize: 14 }}
            disabled={isLoadingEnableCoustomers}
          >
            <span className={styles.button}>Confirm</span>
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

EnableCustomersModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.string.isRequired,
  lastPublish: PropTypes.bool.isRequired,
  isLoadingEnableCoustomers: PropTypes.bool.isRequired,
  numberOfEnabledUsers: PropTypes.number,
};
